import { useLocalStorage } from '@vueuse/core'
import axios, { AxiosError, AxiosResponse } from 'axios'

// Create Instances
const api = axios.create()

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const auth = useLocalStorage('auth_access_token', '')

    if (
      typeof error.response === 'undefined' &&
      error.config?.url?.includes('/auth/user')
    ) {
      auth.value = null
      alert(
        'A network error occurred. ' +
          'This could be a CORS issue or a dropped internet connection. ' +
          'It is not possible for us to know.',
      )
      window.location.reload()
    }

    if (error.response?.data) {
      Object.values(error.response?.data).map((value: any) => {
        if (value === 'token is invalid') {
          auth.value = null
          window.location.reload()
        }
      })
    }

    if (
      error.response?.status &&
      error.response.status >= 500
      // !notificationState.value.open
    ) {
      // show a global notification to avoid add a notification error in every response
      // notificationHandlers.enqueueNotification({
      // 	color: 'danger',
      // 	message: 'Something went wrong. Try refreshing or contact support',
      // 	delay: 8000,
      // })
    }

    return Promise.reject(error)
  },
)

// Headers
export const setAuthHeader = (token: string) => {
  api.defaults.headers.common['Authorization'] = token
}

export const removeAuthHeader = () => {
  delete api.defaults.headers.common['Authorization']
}

export const setBaseUrl = (baseUrl: string) => {
  api.defaults.baseURL = baseUrl
}

export default api
